import { render, staticRenderFns } from "./yw_PerformanceStatistics.vue?vue&type=template&id=4f578256"
import script from "./yw_PerformanceStatistics.vue?vue&type=script&lang=js"
export * from "./yw_PerformanceStatistics.vue?vue&type=script&lang=js"
import style0 from "./yw_PerformanceStatistics.vue?vue&type=style&index=0&id=4f578256&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports